import { useOutletContext } from 'react-router-dom'
import type { SiteContext } from '../components/MainLayout'
import { UpworkIcon } from '../components/icons'
import { StaggerGroup } from '../components/motion'
import { CallToAction, PageIntro, SectionHeading } from '../components/ui'
import { routeFor } from '../config/routes'
import { siteConfig } from '../config/site'
import { usePageMeta } from '../hooks/usePageMeta'

export default function AboutPageV2() {
  const { language, copy } = useOutletContext<SiteContext>()
  const page = copy.about
  usePageMeta({ language, title: page.eyebrow, description: page.intro })
  return (
    <>
      <PageIntro eyebrow={page.eyebrow} title={page.title} text={page.intro} />
      <section className="section profile-section">
        <StaggerGroup className="shell profile-section__grid">
          <figure className="profile-visual">
            <div className="profile-visual__frame">
              <img src={siteConfig.assets.profile} alt={copy.common.profileAlt} width="1254" height="1254" loading="eager" decoding="async" />
            </div>
            <figcaption>FOTIS MYTIKAS / DIGITAL SERVICES</figcaption>
          </figure>
          <div className="profile-copy">
            <p className="eyebrow">{page.profileEyebrow}</p>
            <h2>{page.profileTitle}</h2>
            {page.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            <dl className="profile-details">
              <div><dt>{page.locationLabel}</dt><dd>{siteConfig.location[language]}</dd></div>
              <div><dt>{page.remoteLabel}</dt><dd>{language === 'el' ? siteConfig.location.remoteEl : siteConfig.location.remoteEn}</dd></div>
            </dl>
            <div className="profile-upwork">
              <p>{page.upworkText}</p>
              <a
                className="profile-upwork__link"
                href={siteConfig.contact.upwork}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={copy.common.upworkLabel}
              >
                <UpworkIcon className="upwork-icon" />
                <span>{copy.common.upworkLabel}</span>
              </a>
            </div>
          </div>
        </StaggerGroup>
      </section>
      <section className="section skills-section">
        <div className="shell">
          <SectionHeading eyebrow={page.skillsEyebrow} title={page.skillsTitle} />
          <StaggerGroup className="skills-grid skills-timeline">
            {page.skills.map((group, index) => (
              <article key={group.title}>
                <span className="skills-grid__index">0{index + 1}</span>
                <h3>{group.title}</h3>
                <ul>{group.items.map((item) => <li key={item}>{item}</li>)}</ul>
              </article>
            ))}
          </StaggerGroup>
        </div>
      </section>
      <CallToAction eyebrow="FOTIS MYTIKAS / DIGITAL SERVICES" title={page.ctaTitle} text={page.ctaText} button={copy.common.contact} to={routeFor(language, 'contact')} />
    </>
  )
}
